export default __webpack_public_path__ + "static/media/namespace.1e3dced5.svg";